import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { AgenturModel } from 'app/models/agentur.model';
import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps';
import { runInAction } from 'mobx';
import { AgenturInfoWindow } from '../maps/InfoWindow';
import { AgenturModelMarker } from '../maps/Markers';
import { useHistory } from 'react-router-dom';

export const AgenturMapLegend = observer(() => {
	const { agenturMapsUiStore, uiStore } = useStore();

	return (
		<>
			{uiStore.showMap && agenturMapsUiStore.currentLegend && (
				<>
					{/* {agenturMapsUiStore.mapableItemsWithoutCoordinates.length} without coordinates */}
					<div className="map-legend">
						{agenturMapsUiStore.currentLegend.legendDescription.map((desc) => {
							return (
								<div className="map-legend-item" key={desc.value}>
									<span>{desc.label}</span> <div dangerouslySetInnerHTML={{ __html: desc.value as string }}></div>
								</div>
							);
						})}
					</div>
				</>
			)}
		</>
	);
});

const MapContent = observer(() => {
	const { agenturListUiStore, agenturMapsUiStore } = useStore();
	const map = useMap();

	useEffect(() => {
		if (agenturMapsUiStore.selectedAgt && map) {
			const { lat, lng } = agenturMapsUiStore.selectedAgt;
			if (lat && lng) {
				map.panTo({ lat, lng });
				map.setZoom(12);
			}
		}
	}, [agenturMapsUiStore.selectedAgt, map]);

	const getMarkerColor = (item: AgenturModel) => {
		const legend = agenturMapsUiStore.currentLegend;
		const index = legend.getIndex(item);
		return legend.getColorByIndex(index);
	};

	return (
		<>
			{agenturListUiStore.filteredItems.length > 0 && agenturListUiStore.filteredItems.map((item: AgenturModel) => <SimpleMarker key={item.agtId} item={item} color={getMarkerColor(item)} />)}
			{agenturMapsUiStore.selectedAgt && <MapInfoWindow agt={agenturMapsUiStore.selectedAgt} />}
		</>
	);
});

export const AgenturMap = observer(() => {
	return (
		<>
			<AgenturMapLegend />
			<APIProvider apiKey="AIzaSyAS6Sik2T9tlF-aWgWWg44Lkup6TiwDOI4">
				<Map
					mapId={'map'}
					mapTypeId="roadmap"
					defaultZoom={6}
					defaultCenter={{ lat: 51.1657, lng: 10.4515 }} // Center of Germany
					disableDefaultUI={true}
				>
					<MapContent />
				</Map>
			</APIProvider>
		</>
	);
});

interface IMarkerWithInfowindowProps {
	item: AgenturModel;
	color?: string;
}
export const SimpleMarker = (props: IMarkerWithInfowindowProps) => {
	const { agenturMapsUiStore } = useStore();
	const { item, color } = props;

	const handleClick = (agt: AgenturModel) => {
		runInAction(() => {
			agenturMapsUiStore.selectedAgt = agt;
		});
	};

	return <AgenturModelMarker agt={item} color={color} onClick={handleClick} />;
};

interface IInfoWindow {
	agt: AgenturModel;
}
const MapInfoWindow = (props: IInfoWindow) => {
	const history = useHistory();
	const { agt } = props;
	const { agenturMapsUiStore } = useStore();

	const handleClose = () => {
		runInAction(() => {
			agenturMapsUiStore.selectedAgt = undefined;
		});
	};

	const handleViewDetails = (agtId: number) => {
		handleClose();
		history.push(`/agentur/${agtId}`);
	};

	if (!agt.lat || !agt.lng) {
		return null;
	}

	return <AgenturInfoWindow position={{ lat: agt.lat, lng: agt.lng }} onClose={handleClose} agt={agt} onViewDetails={handleViewDetails} />;
};
